import React, { useEffect, useState } from 'react';
import './splashScreen.css';
import logo from '../../../assets/images/splashScreen.png';

const SplashScreen = ({ onFinish }) => {
    const [showLogo, setShowLogo] = useState(false);

    useEffect(() => {
        const logoTimer = setTimeout(() => {
            setShowLogo(true);
        }, 1000);

        const finishTimer = setTimeout(() => {
            onFinish();
        }, 4000);

        return () => {
            clearTimeout(logoTimer);
            clearTimeout(finishTimer);
        };
    }, [onFinish]);

    return (
        <div className="splash-screen">
            {showLogo && <img src={logo} alt="Logo" className="splash-logo" />}
        </div>
    );
};

export default SplashScreen;
